import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { ModelMetadata } from "../models/Model3D";

type AnimatedComponentPayload = {
  name: string;
  animated: boolean;
}

export type ModelSlice = {
  metadata?: ModelMetadata;
  animatedComponents: string[];
};

const initialState: ModelSlice = {
  animatedComponents: [],
}



export const modelSlice = createSlice({
  name: 'model',
  initialState,
  reducers: {
    setMetadata(state, action: PayloadAction<ModelMetadata | undefined>) {
      state.metadata = action.payload;
    },
    resetComponentState(state) {
      state.animatedComponents = [];
    },
    setAnimatedComponentState(state, action: PayloadAction<AnimatedComponentPayload>) {
      const { animated, name } = action.payload;
      const exists = state.animatedComponents.includes(name);
      if (exists === animated) {
        return;
      }
      if (animated) {
        state.animatedComponents = state.animatedComponents.filter(record => record !== name);
      } else {
        state.animatedComponents = [...state.animatedComponents, name];
      }
    },
    toggleAnimatedComponent(state, action: PayloadAction<string>) {
      const name = action.payload;
      if (state.animatedComponents.includes(name)) {
        state.animatedComponents = state.animatedComponents.filter(record => record !== name);
      } else {
        state.animatedComponents = [...state.animatedComponents, name];
      }
    }
  },
});

export const modelReducer = modelSlice.reducer;
export const modelActions = modelSlice.actions;

